import React from "react";
import { Box, Flex, Link, Text, Stack } from "@chakra-ui/react";
import { LuMessageCircle } from "react-icons/lu";
import { FaXTwitter, FaDiscord } from "react-icons/fa6";

const Footer: React.FC = () => {
  return (
    <Box
      as="footer"
      bg="#18181b"
      color="#a1a1aa"
      mt={10}
      px={{ base: 6, md: 12 }}
      pt={10}
      pb={6}
    >
      {/* Top section: 4 columns */}
      <Flex
        direction={{ base: "column", md: "row" }}
        gap={{ base: 8, md: 12 }}
        maxW="1200px"
        mx="auto"
        pb={8}
        borderBottomWidth="1px"
        borderColor="rgba(255,255,255,0.1)"
      >
        {/* Column 1: COINCAP.IO */}
        <Stack gap={3} flex={1}>
          <Text
            fontSize="xs"
            fontWeight="bold"
            color="white"
            textTransform="uppercase"
            letterSpacing="wider"
          >
            CoinCap.io
          </Text>
          <Link
            href="https://coincap.io/methodology"
            target="_blank" rel="noopener noreferrer"
            fontSize="sm"
            color="#a1a1aa"
            _hover={{ color: "white" }}
          >
            Methodology
          </Link>
          <Link
            href="https://discord.gg/7QKDgNFhTp"
            target="_blank" rel="noopener noreferrer"
            fontSize="sm"
            color="#a1a1aa"
            _hover={{ color: "white" }}
          >
            <Flex alignItems="center" gap={1}>
              <LuMessageCircle size={14} />
              Support (Discord)
            </Flex>
          </Link>
          <Link
            href="/api-docs/"
            target="_blank" rel="noopener noreferrer"
            fontSize="sm"
            color="#a1a1aa"
            _hover={{ color: "white" }}
          >
            Our API
          </Link>
        </Stack>

        {/* Column 2: LEGALS */}
        <Stack gap={3} flex={1}>
          <Text
            fontSize="xs"
            fontWeight="bold"
            color="white"
            textTransform="uppercase"
            letterSpacing="wider"
          >
            Legals
          </Text>
          <Link
            href="https://coincap.io/terms-of-service"
            target="_blank" rel="noopener noreferrer"
            fontSize="sm"
            color="#a1a1aa"
            _hover={{ color: "white" }}
          >
            Terms of Service
          </Link>
          <Link
            href="https://coincap.io/privacy-policy"
            target="_blank" rel="noopener noreferrer"
            fontSize="sm"
            color="#a1a1aa"
            _hover={{ color: "white" }}
          >
            Privacy Policy
          </Link>
        </Stack>

        {/* Column 3: CONNECT WITH US */}
        <Stack gap={3} flex={1}>
          <Text
            fontSize="xs"
            fontWeight="bold"
            color="white"
            textTransform="uppercase"
            letterSpacing="wider"
          >
            Connect With Us
          </Text>
          <Flex gap={3}>
            <Link
              href="https://discord.gg/7QKDgNFhTp"
              target="_blank" rel="noopener noreferrer"
              color="#a1a1aa"
              _hover={{ color: "white" }}
            >
              <FaDiscord size={20} />
            </Link>
            <Link
              href="https://x.com/CoinCap_io"
              target="_blank" rel="noopener noreferrer"
              color="#a1a1aa"
              _hover={{ color: "white" }}
            >
              <FaXTwitter size={20} />
            </Link>
          </Flex>
        </Stack>

        {/* Column 4: COINCAP APP */}
        <Stack gap={3} flex={1}>
          <Text
            fontSize="xs"
            fontWeight="bold"
            color="white"
            textTransform="uppercase"
            letterSpacing="wider"
          >
            CoinCap App
          </Text>
          <Link
            href="https://play.google.com/store/apps/details?id=io.coinCap.coinCap"
            target="_blank" rel="noopener noreferrer"
            fontSize="sm"
            color="#a1a1aa"
            _hover={{ color: "white" }}
          >
            Google Play
          </Link>
          <Link
            href="https://apps.apple.com/us/app/coincap-crypto-portfolio/id1074052280"
            target="_blank" rel="noopener noreferrer"
            fontSize="sm"
            color="#a1a1aa"
            _hover={{ color: "white" }}
          >
            App Store
          </Link>
        </Stack>
      </Flex>

      {/* Bottom section: Logo + disclaimer */}
      <Flex
        direction="column"
        alignItems="center"
        gap={3}
        pt={6}
        maxW="1200px"
        mx="auto"
      >
        <img
          src="/external/cclogo.png"
          alt="CoinCap"
          style={{ height: 28, opacity: 0.7 }}
        />
        <Text fontSize="xs" color="#71717a" textAlign="center" maxW="700px">
          Market data provided by CoinCap. CoinCap is a product of ShapeShift.
          Information is provided "as is" without warranty of any kind. CoinCap
          is not responsible for any trading decisions made based on data
          provided. Cryptocurrency prices are volatile and may differ across
          exchanges.
        </Text>
      </Flex>
    </Box>
  );
};

export default Footer;
